module.exports = __webpack_public_path__ + "img/send_e-mail_hover.e3a32cf5.svg";